// ----------------------------------------------------------------------------
// Template: Pages
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import 'sections/header/header';
import 'sections/headline-block/headline-block';
import 'sections/hero-banner/hero-banner';
import 'sections/hero-carousel/hero-carousel';
import 'sections/h1-plus-CTA/h1-plus-CTA';
import 'sections/intro-block/intro-block';
import 'sections/content-panel/content-panel';
import 'sections/feature-panel/feature-panel';
import 'sections/icon-block/icon-block';
import 'sections/how-to-measure/how-to-measure';
import 'sections/cta-grid/cta-grid';
import 'sections/holiday-banner/holiday-banner';
import 'sections/banner/banner-block';
import 'sections/video-image-banner/video-image-banner';
import 'sections/video-image-text-block/video-image-text-block';
import 'sections/faqs/faqs';
import 'sections/technical-features/technical-features';
import 'sections/tabs/tabs';
import 'sections/tabs/tabs--stores';
import 'sections/product-slider/product-slider';
import 'sections/blog-posts/blog-posts';
import 'sections/stretch-range/stretch-range';
import 'sections/newsletter/newsletter';
import 'sections/page-header/page-header';
import 'sections/related-blogs/related-blogs';
import 'sections/rich-text/rich-text';
import 'sections/title-block/title-block';
import 'sections/footer/footer';
import 'sections/press-block/press-block';
import 'sections/image-banner/image-banner';
import 'sections/guarantee-bar/guarantee-bar';
import 'sections/value-bar/value-bar';
import 'sections/campaign-grid/campaign-grid';
import 'sections/expandable-cards/expandable-cards';
import 'sections/fit-cards/fit-cards';
import 'sections/fit-guide/fit-guide';
import 'sections/scrolling-gallery/scrolling-gallery';
import 'sections/location-finder/location-finder';
import 'sections/two-column-block/two-column-block';
import 'sections/animation-block/animation-block';
import 'sections/stores/stores';
import 'sections/stores-carousel/stores-carousel';
import 'sections/featured-tiles/featured-tiles';
import 'sections/page-tabs/page-tabs';
import 'sections/image-product-grid/image-product-grid';
import 'snippets/country-modal/country-modal';
import 'sections/feature-callouts/feature-callouts';
import 'sections/sustainability-list/sustainability-list';
import 'sections/reviews-carousel/reviews-carousel';
import 'sections/fit-value-prop/fit-value-prop';
import 'sections/fabric-carousel/fabric-carousel';
import 'sections/fabrics-page-hero/fabrics-page-hero';
import 'sections/page-hero-store/page-hero-store';
import 'sections/events-programs/events-programs';
import 'sections/retail-partners-cta/retail-partners-cta';

// Styles
import './_pages.scss';
